export default `
  <strong class="sub-tit">디지털 혁신에 책임을 더해, 지속가능한 내일로 나아갑니다</strong>
  <p>디지털 기술로 세상을 연결해 온 이모션글로벌은 이제 기술을 넘어 '지속가능한 미래'를 향한 책임 있는 걸음을 내딛고 있습니다. 우리는 고객과 파트너, 그리고 사회 구성원 모두가 함께 성장하는 디지털 생태계를 만드는 데 깊은 책임감을 느끼며, 진정성 있는 ESG 경영을 실천해 가고 있습니다.</p>
  <p>기술의 변화가 빠를수록 기업의 윤리적 기준과 투명한 의사결정은 더욱 견고해야 합니다. 이모션글로벌은 경영의 모든 과정에서 공정성을 최우선으로 두고, 이해관계자 누구나 신뢰할 수 있는 투명한 지배구조를 지향합니다. 우리가 생각하는 지속가능성의 출발점은 바로 '사람'입니다. 임직원 개개인의 다양성을 포용하고 자율성을 존중하는 일터, 서로 신뢰하며 함께 몰입할 수 있는 건강한 조직문화를 만들어 가고 있습니다. 이와 함께 우리의 소중한 비즈니스 파트너들과도 수평적이고 공정한 협력 구조를 다지며 상생의 가치를 실현하고 있습니다.</p>
  <p>더불어, 기후변화와 환경 문제에 선제적으로 대응하기 위해 업무 프로세스의 디지털 효율성을 높이고 친환경 경영 기틀을 다지고 있습니다. 환경과 사회를 이롭게 하는 비즈니스는 우리 경영의 선택이 아닌, 모든 의사결정에 자연스럽게 스며 있는 이모션글로벌의 본질적인 원칙입니다.</p>
  <p>이모션글로벌은 앞으로도 책임 경영과 지속가능한 성장의 균형을 잃지 않으며, 우리를 둘러싼 모든 이해관계자에게 가장 신뢰받는 파트너가 되겠습니다. 혁신에 책임을 더해 더 가치 있는 세상을 만들어 갈 이모션글로벌의 여정에 따뜻한 관심과 성원을 부탁드립니다.</p>
  <p class="closing">감사합니다.</p>
  <div class="sign-off">
    <p class="company"><strong>주식회사 이모션글로벌</strong></p>
  </div>
`;
